import { ServiceTypes } from '../../../modules/journey-canvas/utility/TypeDefs';

import canvasIconDB2 from '../../../assets/images/Db2ServiceIcon.svg';
import canvasIconExternal from '../../../assets/images/ExternalServiceIcon.svg';
import canvasIconMQ from '../../../assets/images/MqServiceIcon.svg';
import canvasIcon from '../../../assets/images/NewCanvasIcon.svg';
import canvasIconSOAP from '../../../assets/images/SoapServiceIcon.svg';

/**
 * @method getServiceTypeIcon
 * @description Returns the icon for a given service type.
 * @param {string | undefined} serviceType - The service type.
 */
export const getServiceTypeIcon = (serviceType: string | undefined) => {
  const service = serviceType?.toLowerCase();
  switch (service) {
    case ServiceTypes.BUSINESS:
      return canvasIcon;
    case ServiceTypes.EXTERNAL:
      return canvasIconExternal;
    case ServiceTypes.MQ:
      return canvasIconMQ;
    case ServiceTypes.DB2:
      return canvasIconDB2;
    case ServiceTypes.SOAP:
      return canvasIconSOAP;

    default:
      return canvasIcon;
  }
};
